var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetailsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 99,
    viewBox: "0 0 101 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 99,
    rx: 49.5,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2440_76840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2985 30.2397L75.4514 61.0771C76.1172 62.208 76.5 63.519 76.5 64.9186C76.5 69.169 72.9867 72.6149 68.6528 72.6149H50.5L44.2223 49.5L50.5 26.3853C53.4067 26.3853 55.9424 27.9365 57.2985 30.2397Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7015 30.2397L25.5484 61.0771C24.8828 62.208 24.5 63.519 24.5 64.9186C24.5 69.169 28.0132 72.6149 32.3471 72.6149H50.5V26.3853C47.5933 26.3853 45.0576 27.9365 43.7015 30.2397Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7334 62.6163L54.5805 31.7792C53.7623 30.3888 52.2599 29.5114 50.635 29.4663L66.1608 69.5367H68.653C71.2488 69.5367 73.3612 67.465 73.3612 64.919C73.3612 64.1104 73.1436 63.3141 72.7334 62.6163Z",
    fill: "#BA9A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6804 62.6165C70.0351 63.3142 70.2223 64.1105 70.2223 64.9191C70.2223 67.4651 68.4008 69.5368 66.1607 69.5368H32.3472C29.7513 69.5368 27.6389 67.4651 27.6389 64.9191C27.6389 64.1105 27.8566 63.3142 28.2667 62.6165L46.4195 31.7794C47.2608 30.351 48.8239 29.4634 50.5 29.4634C50.545 29.4634 50.59 29.4644 50.635 29.4665C52.0297 29.5199 53.3177 30.3951 54.0197 31.7794L69.6804 62.6165Z",
    fill: "#FFD736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 59.2749V64.4057C51.9449 64.4057 53.1157 63.2574 53.1157 61.8402C53.1157 60.4232 51.9449 59.2749 50.5 59.2749Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 59.2749C50.7888 59.2749 51.0232 60.4232 51.0232 61.8403C51.0232 63.2575 50.7888 64.4058 50.5 64.4058C49.0551 64.4058 47.8843 63.2575 47.8843 61.8403C47.8843 60.4232 49.0551 59.2749 50.5 59.2749Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 37.2129V56.1968C51.9449 56.1968 53.1157 55.0476 53.1157 53.6314V39.7783C53.1157 38.3612 51.9449 37.2129 50.5 37.2129Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 37.2129C50.7888 37.2129 51.0232 38.3612 51.0232 39.7783V53.6314C51.0232 55.0475 50.7888 56.1968 50.5 56.1968C49.0551 56.1968 47.8843 55.0476 47.8843 53.6314V39.7783C47.8843 38.3612 49.0551 37.2129 50.5 37.2129Z",
    fill: "#000624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2440_76840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    fill: "white",
    transform: "translate(24.5 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetailsSvg);
export default __webpack_public_path__ + "static/media/AccountDetailsSvg.8c95c08b2c808861bd0d0b777869c040.svg";
export { ForwardRef as ReactComponent };